import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import FaqRoute from "./faq";

// Guidelines is a faq alias
export default class GuidelinesRoute extends FaqRoute {
  constructor() {
    super(...arguments);
    _defineProperty(this, "pageId", "guidelines");
  }
}